var map = {
	"./content-deco-1.webp": 1441,
	"./content-deco-2.webp": 1442,
	"./deposit-icon.webp": 1443,
	"./home-icon-active.webp": 1444,
	"./home-icon.webp": 1445,
	"./live-icon-active.webp": 1446,
	"./live-icon.webp": 1447,
	"./me-icon-active.webp": 1448,
	"./me-icon.webp": 1449,
	"./product-overview-bg.webp": 1450,
	"./promos-icon-active.webp": 1451,
	"./promos-icon.webp": 1452,
	"./services-bg.webp": 1453,
	"./sponsor-icon-active.webp": 1454,
	"./sponsor-icon.webp": 1455,
	"./vip-icon.webp": 1456,
	"./withdraw-icon.webp": 1457,
	"./wwr-img.webp": 1458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;